import SearchOperator from "./SearchOperator";

class SearchField {
  static options = {
    id: "searchField",
    value: "Search Field",
    type: "searchKey",
    operators: [],
  };

  static createField(options = this.options) {
    return {
      ...this.options,
      ...options,
    };
  }
}

export const serialIdField = SearchField.createField({
  id: "serialNo",
  value: "Serial Id",
  operators: [
    SearchOperator.equalsOperator({ customSuggestion: true }),
    SearchOperator.containsOperator({ customInput: true }),
    SearchOperator.startsWithOperator({ customInput: true }),
    SearchOperator.endsWithOperator({ customInput: true }),
    SearchOperator.inOperator({ isMultiSelect: true, customSuggestion: true }),
  ],
});

export const vehicleKeyField = SearchField.createField({
  id: "vehicleKey",
  value: "Vehicle Key",
  operators: [
    SearchOperator.equalsOperator({ customSuggestion: true }),
    SearchOperator.containsOperator({ customInput: true }),
    SearchOperator.startsWithOperator({ customInput: true }),
    SearchOperator.endsWithOperator({ customInput: true }),
    SearchOperator.inOperator({ isMultiSelect: true, customSuggestion: true }),
    SearchOperator.isOperator({
      input: false,
      disable: true,
      results: [
        { id: "isEmpty", value: "empty" },
        { id: "isNotEmpty", value: "not empty" },
      ],
    }),
  ],
});

export const statusField = SearchField.createField({
  id: "active",
  value: "Status",
  operators: [
    SearchOperator.equalsOperator({
      disable: true,
      results: [
        { id: "true", value: "active" },
        { id: "false", value: "inactive" },
      ],
    }),
  ],
});

export const certificateField = SearchField.createField({
  id: "certAvailable",
  value: "Certificate",
  type: "searchKey",
  operators: [
    SearchOperator.equalsOperator({
      disable: true,
      results: [
        { id: "true", value: "Yes" },
        { id: "false", value: "No" },
      ],
    }),
  ],
});

export const vehicleFeaturesField = SearchField.createField({
  id: "vehicle.vehicleFeatures.active",
  value: "Vehicle Features",
  type: "searchKey",
  operators: [
    SearchOperator.equalsOperator({
      disable: true,
      results: [
        { id: "true", value: "enabled" },
        { id: "false", value: "disable" },
      ],
    }),
  ],
});

export const vehicleSubscriptionsField = SearchField.createField({
  id: "vehicle.subscriptions.active",
  value: "Vehicle Subscriptions",
  operators: [
    SearchOperator.equalsOperator({
      disable: true,
      results: [
        { id: "true", value: "active" },
        { id: "false", value: "inactive" },
      ],
    }),
  ],
});

export const vehicleGroupsField = SearchField.createField({
  id: "vehicle.vehicleGroups.vehicleGroupId",
  value: "Vehicle Groups",
  operators: [SearchOperator.inOperator({ isMultiSelect: true })],
});

export const huManufacturedField = SearchField.createField({
  id: "serialNoCreatedAt",
  value: "HU Manufactured",
  operators: [SearchOperator.betweenOperator({ isDate: true, disable: true })],
});

export const vehicleManufacturedField = SearchField.createField({
  id: "vehicleKeyUpdatedAt",
  value: "Vehicle Manufactured",
  operators: [SearchOperator.betweenOperator({ isDate: true, disable: true })],
});

export const purchasedField = SearchField.createField({
  id: "vehicle.vehiclePurchaseDetails.purchaseDate",
  value: "Purchased",
  operators: [SearchOperator.betweenOperator({ isDate: true, disable: true })],
});

export const lastSeenField = SearchField.createField({
  id: "deviceConnectivityEvents.eventTime",
  value: "Last seen",
  operators: [SearchOperator.betweenOperator({ isDate: true, disable: true })],
});
